import { api } from './apiClient';
import type { User } from '@/types/auth';

export interface AccountScreen {
  id: string;
  label: string;
  deviceIdSuffix: string;
  firstSeenAt: string;
  lastSeenAt: string;
  current: boolean;
}
export interface AccountScreensResponse {
  limit: number | null;
  screens: AccountScreen[];
}

export const accountApi = {
  updateDisplayName(displayName: string): Promise<{ user: User }> {
    return api<{ user: User }>('/api/account/me', {
      method: 'PATCH',
      body: { displayName },
      auth: true,
    });
  },
  getScreens(): Promise<AccountScreensResponse> {
    return api<AccountScreensResponse>('/api/account/screens', { auth: true });
  },
  removeScreen(id: string): Promise<void> {
    return api<void>(`/api/account/screens/${encodeURIComponent(id)}`, { method: 'DELETE', auth: true });
  },
};
